module.exports = __webpack_public_path__ + "static/product-strategy-main-banner-07de65af58e50392f3320407798743a2.svg";